import React from 'react';
import { Services } from '../components/Services';
export function ServicesPage() {
  return <main className="pt-24" data-id="element-238">
      <Services data-id="element-239" />
    </main>;
}